import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIndustries = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "industry",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 1.5H1.5V2V14V14.5H2H14H14.5V14V4V3.15024L13.7572 3.56292L10 5.65024V4V3.15024L9.25718 3.56292L5.5 5.65024V2V1.5H5H2ZM2.5 13.5V2.5H4.5V6.5V7.34976L5.24282 6.93708L9 4.84976V6.5V7.34976L9.74282 6.93708L13.5 4.84976V13.5H12V9.5V9H11.5H8.5H8V9.5V13.5H2.5ZM9 13.5H11V10H9V13.5Z",
			fill: "#696B79",
			style: {
				fill: "#696B79",
				fill: "color(display-p3 0.4118 0.4196 0.4745)",
				fillOpacity: 1
			}
		})
	})
});
export default SvgIndustries;
